import {NgModule} from '@angular/core';
import {InputPrimitiveComponent} from './input-primitive.component';

@NgModule({
  declarations: [InputPrimitiveComponent],
  exports: [InputPrimitiveComponent],
  imports: [],
})
export class InputPrimitiveModule {}
